import { render, staticRenderFns } from "./MidwifeSignoffOverview.vue?vue&type=template&id=45e33223"
import script from "./MidwifeSignoffOverview.vue?vue&type=script&lang=js"
export * from "./MidwifeSignoffOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports